// removed by extract-text-webpack-plugin
module.exports = {"tag":"StatusTag__tag"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/StatusTag/StatusTag.scss
// module id = 1819
// module chunks = 8